import { isNil } from "@hopper-ui/components";

export function getRole(element: HTMLElement) {
    return element.getAttribute("role");
}

export function getClosestRole(element: HTMLElement, role: string): HTMLElement {
    return element.closest(`[role=${role}]`)!;
}

export function getModalInformation(element: HTMLElement) {
    const dialogElement = getClosestRole(element, "dialog");
    if (isNil(dialogElement)) {
        return undefined;
    }

    return getTelemetryName(dialogElement);
}

export function findCheckboxText(input: HTMLInputElement) {
    // Orbit styles checkbox by hidding the default box and added a new one on top.
    return input.parentElement ? getTelemetryName(input.parentElement) : getTelemetryName(input);
}

export function findRadioText(radio: HTMLInputElement) {
    const dataTelemetry = radio.closest("[data-telemetry]");
    if (!isNil(dataTelemetry)) {
        return (dataTelemetry as HTMLElement).dataset["telemetry"];
    } else if (!isNil(radio.closest("[data-public]"))) {
        const label =
            radio.ariaLabel ||
            labelledBy(radio) ||
            Array.from(radio.labels ?? []).find(l => l.dataset.telemetry)?.dataset.telemetry;
        if (label) {
            return label;
        }
    }

    const env = process.env.APP_ENV;
    if (env === "msw" || env === "local") {
        console.error(`[automatic-tracking] Unable to find attribute data-telemetry for tag <${radio.tagName}>`);
    }

    return "Redacted";
}

export function getTelemetryName(element: HTMLElement) {
    const dataTelemetry = element.closest("[data-telemetry]");
    if (!isNil(dataTelemetry)) {
        return (dataTelemetry as HTMLElement).dataset["telemetry"];
    } else if (!isNil(element.closest("[data-public]"))) {
        const label = element.ariaLabel || labelledBy(element) || element.textContent;

        if (label) {
            return label;
        }
    }

    const env = process.env.APP_ENV;
    if (env === "msw" || env === "local") {
        console.error(`[automatic-tracking] Unable to find attribute data-telemetry for tag <${element.tagName}>`);
    }

    return "Redacted";
}

function labelledBy(element: HTMLElement): string | undefined {
    const ariaLabelledBy = element.attributes.getNamedItem("aria-labelledby")?.value;

    if (ariaLabelledBy) {
        // if there is multiple labelledBy values, take the first one
        const firstLabelledBy = ariaLabelledBy.split(" ")[0];
        const label = document.getElementById(firstLabelledBy);

        if (isNil(label)) {
            return undefined;
        }

        return getTelemetryName(label);
    }

    return undefined;
}
